import React from "react";
import { useLang } from "../context/LanguageContext";
import { useReveal, useCountUp } from "../hooks/useReveal";
import { stats, heroImages } from "../mock";

const StatItem = ({ stat, visible, lang }) => {
  const count = useCountUp(stat.value, visible);
  return (
    <div className="text-center">
      <div className="font-display font-extrabold text-4xl md:text-5xl text-white">
        {count}{stat.suffix}
      </div>
      <div className={`mt-2 text-sm md:text-base text-white/80 ${lang === "zh" ? "font-zh" : ""}`}>{stat[lang]}</div>
    </div>
  );
};

const Stats = () => {
  const { t, lang } = useLang();
  const [ref, visible] = useReveal({ threshold: 0.3 });

  return (
    <section id="por-que" ref={ref} className="relative py-20 md:py-24 overflow-hidden">
      <img src={heroImages.skyline} alt="Mexico City" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(82,32,44,.94), rgba(110,42,58,.85))" }} />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className={`reveal ${visible ? "is-visible" : ""} text-center max-w-2xl mx-auto mb-14`}>
          <span className="text-sm font-bold uppercase tracking-wider text-white/80">{t.why.tag}</span>
          <h2 className={`font-display font-bold text-3xl md:text-4xl mt-3 text-white ${lang === "zh" ? "font-zh" : ""}`}>{t.why.title}</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          {stats.map((s, i) => <StatItem key={i} stat={s} visible={visible} lang={lang} />)}
        </div>
      </div>
    </section>
  );
};

export default Stats;
